<main class="flex justify-center items-center h-screen text-start">
  <div class="md:w-[35rem] w-[25rem] flex flex-col gap-4 border-[1.5px] border-gray-200 rounded-lg p-7">

      <div class="flex flex-col gap-5">
        <h2 [routerLink]="['/login']" class="text-base font-semibold text-[#4B4B4B] cursor-pointer"> <span class="text-[#8A8AA3] text-base ms-0.5 me-2"> <i [routerLink]="['/']" class="bi text-[#8A8AA3] text-base cursor-pointer" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i> {{ 'auth.back' | translate }}  </span>{{ 'auth.new_password.title' | translate }}</h2>
        <p class="text-[0.87rem] text-[#4B4B4B] leading-7">{{ 'auth.new_password.description' | translate }}</p>
      </div>

    <form (submit)="submit(password.value, confirmPassword.value, $event)">

      <div class="input-group">
        <label for="password">
          {{ 'auth.fields.password' | translate }}<span class="text-red-500">*</span>
          <i class="bi bi-exclamation-circle-fill ms-2 text-sm text-[#D1D1DB]"
            [title]="'auth.password_requirements' | translate">
          </i>
        </label>

        <div class="relative w-full">
          <input [type]="showPassword ? 'text' : 'password'" #password name="password" id="password" autocomplete="new-password" ngModel required minlength="8"
            class="w-full h-10 px-4 py-2 mt-2 text-sm border-2 border-[#4B4B4B] rounded-lg focus:outline-none focus:border-[#007AFF] ps-12 text-start" />

          <span (click)="togglePassword()" class="absolute inset-y-7.5 end-4 flex items-center cursor-pointer">
            <ng-container *ngIf="!showPassword; else eyeSlash">
              <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.25 7C15.25 8 13.5 13.25 8 13.25C2.5 13.25 0.75 8 0.75 7C0.75 6 2.5 0.75 8 0.75C13.5 0.75 15.25 6 15.25 7Z"
                  stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M10.25 7C10.25 8.24264 9.24264 9.25 8 9.25C6.75736 9.25 5.75 8.24264 5.75 7C5.75 5.75736 6.75736 4.75 8 4.75C9.24264 4.75 10.25 5.75736 10.25 7Z"
                  stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </ng-container>
            <ng-template #eyeSlash>
              <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.25 7C15.25 8 13.5 13.25 8 13.25C2.5 13.25 0.75 8 0.75 7C0.75 6 2.5 0.75 8 0.75C13.5 0.75 15.25 6 15.25 7Z"
                  stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M10.25 7C10.25 8.24264 9.24264 9.25 8 9.25C6.75736 9.25 5.75 8.24264 5.75 7C5.75 5.75736 6.75736 4.75 8 4.75C9.24264 4.75 10.25 5.75736 10.25 7Z"
                  stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1 1L15 13" stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </ng-template>
          </span>
        </div>

      </div>

      <div class="input-group">
        <label for="password">
          {{ 'auth.fields.confirm_password' | translate }}<span class="text-red-500">*</span>
          <i class="bi bi-exclamation-circle-fill ms-2 text-sm text-[#D1D1DB]"
            [title]="'auth.password_requirements' | translate">
          </i>
        </label>

        <div class="relative w-full">
          <input [type]="showConfirmPassword ? 'text' : 'password'" #confirmPassword name="confirmPassword" id="confirmPassword" ngModel required minlength="8"
            class="w-full h-10 px-4 py-2 mt-2 text-sm border-2 border-[#4B4B4B] rounded-lg focus:outline-none focus:border-[#007AFF] ps-12 text-start" />

          <span (click)="toggleConfirmPassword()" class="absolute inset-y-7.5 end-4 flex items-center cursor-pointer">
            <ng-container *ngIf="!showConfirmPassword; else eyeSlash">
              <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.25 7C15.25 8 13.5 13.25 8 13.25C2.5 13.25 0.75 8 0.75 7C0.75 6 2.5 0.75 8 0.75C13.5 0.75 15.25 6 15.25 7Z"
                  stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M10.25 7C10.25 8.24264 9.24264 9.25 8 9.25C6.75736 9.25 5.75 8.24264 5.75 7C5.75 5.75736 6.75736 4.75 8 4.75C9.24264 4.75 10.25 5.75736 10.25 7Z"
                  stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </ng-container>
            <ng-template #eyeSlash>
              <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.25 7C15.25 8 13.5 13.25 8 13.25C2.5 13.25 0.75 8 0.75 7C0.75 6 2.5 0.75 8 0.75C13.5 0.75 15.25 6 15.25 7Z"
                  stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M10.25 7C10.25 8.24264 9.24264 9.25 8 9.25C6.75736 9.25 5.75 8.24264 5.75 7C5.75 5.75736 6.75736 4.75 8 4.75C9.24264 4.75 10.25 5.75736 10.25 7Z"
                  stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1 1L15 13" stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </ng-template>
          </span>
        </div>

      </div>

      <p *ngIf="errorMessage" class="text-red-500 text-sm mt-3">{{errorMessage}}</p>

      <button class="generic-submit-button flex justify-center items-center gap-2" type="submit" [disabled]="loading">
        <span *ngIf="loading" class="w-3 h-3 border border-t-0 border-white rounded-full animate-spin"></span>
        {{ 'auth.new_password.submit' | translate }}
      </button>
    </form>
  </div>
</main>
